<div class="project-instructions" [innerHTML]="instructions"></div>
